import "./contact.css";
import * as Yup from "yup";
import { useState } from "react";
import { Formik, Form } from "formik";
import { useSelector } from "react-redux";
import { Row, Col } from "react-bootstrap";
import Toaster from "../../components/Toast/Toast";
import { ContactUs } from "../../api/modules/b2droppie.class";
import TextInput from "../../components/TextInput/TextInput";

const Contact = () => {
  const [error, setError] = useState({ success: "", error: "" });
  const isDarkMode = useSelector((state) => state.theme.darkMode);

  const initialValues = {
    email: "",
    message: "",
    first_name: "",
    last_name: "",
    contact_number: "",
  };

  const SignupSchema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    message: Yup.string()
      .min(15, "Must be at least 15 characters")
      .required("Required"),
    first_name: Yup.string().required("First  Name is required"),
    last_name: Yup.string().required("Last  Name is required"),
    contact_number: Yup.string().required("Contact number is required"),
  });

  const handleSubmit = (values, { resetForm }) => {
    try {
      const api = async () => {
        const res = ContactUs(values);
        res
          .then((result) => {})
          .catch((err) => {
            console.log("err", err);
          });

        setError((prev) => ({
          ...prev,
          success: res?.data?.message || "Request Submitted Successfully",
          error: res?.data?.error?.message || "",
        }));
      };
      api();
      resetForm();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Toaster message={error} />
      <div
        className={`px-5 pt-5 mb-3 contact-form-main ${isDarkMode ? "dark" : "light"}`}
      >
        <h1
          className={`${isDarkMode ? "text-lavender-gray" : "text-deep-purple"}`}
        >
          Contact Us
        </h1>
        <div>
          <p>
            Before submitting a support ticket, first check if you find the
            answer to your question here: Frequently Asked Questions
          </p>
          <p>
            Please fill out the contact form below with your correct email
            address and a detailed description of your request.
          </p>
          <p>
            Our team will work to respond to your ticket within 24 hours.
            Responses may take longer due to occasional heavy traffic.
          </p>
        </div>
        <Formik
          enableReinitialize
          onSubmit={handleSubmit}
          initialValues={initialValues}
          validationSchema={SignupSchema}
        >
          {({ values, errors, touched, handleChange, handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col className="mt-2" md={6}>
                  <div>
                    <TextInput
                      type="text"
                      name="first_name"
                      label="First Name"
                      isDarkMode={isDarkMode}
                      onChange={handleChange}
                      style={{ width: "100%" }}
                      value={values?.first_name}
                      className={`${isDarkMode ? "dark-input-bg" : "light-input-bg"}`}
                      placeholder="Enter your First Name"
                    />

                    <span className="error">
                      {errors?.first_name &&
                        touched?.first_name &&
                        errors?.first_name}
                    </span>
                  </div>
                </Col>
                <Col className="mt-2" md={6}>
                  <div>
                    <TextInput
                      type="text"
                      name="last_name"
                      label="Last Name"
                      isDarkMode={isDarkMode}
                      onChange={handleChange}
                      value={values?.last_name}
                      style={{ width: "100%" }}
                      className={`${isDarkMode ? "dark-input-bg" : "light-input-bg"}`}
                      placeholder="Enter your Last Name"
                    />

                    <span className="error">
                      {errors?.last_name &&
                        touched?.last_name &&
                        errors?.last_name}
                    </span>
                  </div>
                </Col>
                <Col className="mt-2" md={6}>
                  <div>
                    <TextInput
                      type="email"
                      name="email"
                      label="Email"
                      value={values?.email}
                      onChange={handleChange}
                      isDarkMode={isDarkMode}
                      style={{ width: "100%" }}
                      className={`${isDarkMode ? "dark-input-bg" : "light-input-bg"}`}
                      placeholder="Email Address"
                    />

                    <span className="error">
                      {errors?.email && touched?.email && errors?.email}
                    </span>
                  </div>
                </Col>
                <Col className="mt-2" md={6}>
                  <div>
                    <TextInput
                      type="text"
                      name="contact_number"
                      label="Contact Number"
                      onChange={handleChange}
                      isDarkMode={isDarkMode}
                      style={{ width: "100%" }}
                      className={`${isDarkMode ? "dark-input-bg" : "light-input-bg"}`}
                      value={values?.contact_number}
                      placeholder="Enter your Contact"
                    />

                    <span className="error">
                      {errors?.contact_number &&
                        touched?.contact_number &&
                        errors?.contact_number}
                    </span>
                  </div>
                </Col>
              </Row>

              <div className="mt-2">
                <TextInput
                  type="text"
                  name="message"
                  label="Message"
                  textarea={true}
                  isDarkMode={isDarkMode}
                  onChange={handleChange}
                  value={values?.message}
                  style={{ width: "100%" }}
                  className={`${isDarkMode ? "dark-input-bg" : "light-input-bg"}`}
                  placeholder="Please ensure your description is accurate and thorough to facilitate a more accurate response."
                />
                <span className="error">
                  {errors?.message && touched?.message && errors?.message}
                </span>
              </div>
              <button
                className="w-10 w-md-100 mt-4 filled-medium-deep-yellow-btn-dark"
                type="submit"
              >
                <span>Submit</span>
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default Contact;
